export default {
  activeCampaigns(state) {
    return state.campaigns.filter(campaign => campaign.live);
  },
  inactiveCampaigns(state) {
    return state.campaigns.filter(campaign => !campaign.live);
  },
  instantPollCampaigns(state) {
    return state.campaigns.filter(campaign => campaign.campaign_type === 'instant_poll').map(campaign => campaign.id);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign/getters.js